import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Idle } from "idlejs/dist";

import { Project } from "../interfaces/project";

import { AuthenticationService } from "../services/authentication.service";
import { ProjectsService } from "../services/projects.service";
import { PlansService } from "../services/plans.service";
import { ActivityService } from "../services/activity.service";
import { RequestService } from "../services/request.service";

@Component({
  selector: "app-project",
  templateUrl: "./project.component.html",
  styleUrls: ["./project.component.css"],
})
export class ProjectComponent implements OnInit {
  project: Project;
  iframeContent: any;
  content: any = null;
  url: any;
  actualUrl: any;
  parameters: any = {};
  info: any = {};
  query = "";
  time = 10; //tiempo de espera en minutos
  idle = new Idle();
  activityInfo: any = {};
  userId = "";
  timestamp = Date.now();
  errorMessage = "";
  today = new Date();

  @ViewChild("myDiv") myDiv: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private projectService: ProjectsService,
    private planService: PlansService,
    private authenticationService: AuthenticationService,
    private activityService: ActivityService,
    private requestService: RequestService
  ) {}

  ngOnInit() {
    const projectId = this.activatedRoute.snapshot.params.pid;
    this.authenticationService.getStatus().subscribe((status) => {
      if (status != null) {
        this.userId = status.uid;
        this.projectService
          .getProjectById(projectId)
          .valueChanges()
          .subscribe(
            (data: Project) => {
              this.project = data;
              const userProject = this.project.users[this.userId];
              const endDate = userProject.date_expiration;
              const validaDate = new Date(endDate);
              if (this.today <= validaDate) {
                this.showIframe(
                  this.project.parameters,
                  this.project.info,
                  this.project.user,
                  this.project.pass,
                  this.project.url_auth
                );
              } else {
                this.updateRequest(status.email, projectId);
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
    });

    // this.idle
    // .whenNotInteractive()
    // .within(this.time, 1000) //tiempo de espera en segundos
    // .do(() => this.confirmMessage())
    // .start();
  }
  confirmMessage() {
    let text;
    const box = confirm("¿Salir?");

    if (box === true) {
      text = "ok";
      this.idle.stop();
      this.router.navigate(["home"]);
    } else {
      text = "false";
      this.idle.restart();
    }
  }

  showIframe(parameters, info, user, pass, authUrl) {
    this.url =
      info.protocol + "//" + info.host + ":" + info.port + info.path + "?";
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < parameters.length; i++) {
      this.query += parameters[i].name + "=" + parameters[i].value + "&";
    }
    this.url += this.query + "uid=" + user + "&pwd=" + pass;
    // tslint:disable-next-line: max-line-length
    this.iframeContent = this.iframeContent =
      '<iframe src="https://itlligence.com/iframe/redirect.php?u=' +
      btoa(this.url) +
      "&a=" +
      authUrl +
      '" width="100%" height="750"></iframe>';
  }

  updateRequest(userEmail, projectId) {
    const request = {
      email: userEmail,
      product: {
        pid: projectId,
      },
    };
    this.requestService
      .setRequestStatus(request, "caducado")
      .then(() => {
        this.errorMessage =
          "El acceso al producto ha caducado. Es necesario volver a realizar la compra.";
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /* setActivity(projectId, planDuration, planType, endDate) {
    const ids = [projectId, this.userId].sort();
    const activityId = ids.join('|');


    this.activityService.getActivity(activityId).valueChanges().subscribe(
      (data) => {
        let activity;
        let history;
        if (data != null) {
          this.activityInfo = data;
          console.log(this.activityInfo);
          if (planType === 'horas') {
            activity = {
              aid: activityId,
              total_time: planDuration,
              date_expiration: endDate,
              used_time: 0,
              type: planType
            };
          } else {
            history = {
              hid: Date.now(),
              last_access: this.activityInfo['last_access']
            };
            activity = {
              aid: activityId,
              date_expiration: endDate,
              last_access: this.today.toString(),
              type: planType
            };
          }
        } else { // cuando entramos la primera vez, creamos la actividad
          if (planType === 'horas') {
            activity = {
              aid: activityId,
              total_time: planDuration,
              date_expiration: endDate,
              used_time: 0,
              type: planType
            };
          } else {
            activity = {
              aid: activityId,
              date_expiration: endDate,
              last_access: this.today.toString(),
              type: planType
            };
          }
          this.activityService.createActivity(activity).then(
            () => {

            }).catch((error) => {
              console.log(error);
            });
        }
    }, (error) => {
      console.log(error);
    });
  } */
}
